import { z } from 'zod';
import { BuyerVisibleAdditionalCertificateSchema } from '../caregiver/certificate.schema.js';
// Phase 9e — the care professional profile a buyer (facility user or homecare
// client) sees for a booked shift: name + role + credential currency + tenure.
// No PHI; no PII beyond display name. Split out of buyer-views.schema.ts
// (Convention 06) when doc 16 added additionalCertificates.
const BuyerVisibleCredentialSchema = z.object({
    type: z.enum(['PROFESSIONAL_CERT', 'CPR', 'VSC', 'TB_TEST', 'INSURANCE']), // 2026-08: -VACCINATION, +CPR (RN/RPN/PSW/DSW)
    label: z.string(), // "NACC certificate" / "Vulnerable Sector Check" / etc.
    isCurrent: z.boolean(),
    expiresAt: z.string().nullable(), // ISO date (YYYY-MM-DD) or null when N/A
});
export const BuyerVisibleCaregiverProfileSchema = z.object({
    caregiverId: z.string().uuid(),
    displayName: z.string(), // preferred name OR legal given+surname
    roleCodeForThisShift: z.string(),
    credentials: z.array(BuyerVisibleCredentialSchema),
    // Doc 16 — catalog certificates only; OTHER ones are a bare count (lock 3a).
    additionalCertificates: z.array(BuyerVisibleAdditionalCertificateSchema),
    otherCertificateCount: z.number().int().min(0),
    monthsOnPlatform: z.number().int().min(0),
    // Phase 17 (change-list 1.2) — prior-career experience, DERIVED from the
    // caregiver's work-history rows (union of intervals, so concurrent jobs are
    // not double-counted). Distinct from `monthsOnPlatform`, which is tenure on
    // TrueCare specifically.
    //
    // This is the ONLY thing a buyer ever sees from work history. The underlying
    // rows (employer, comments) and the résumé are caregiver + operator only —
    // do NOT widen this shape to include them.
    totalYearsExperience: z.number().int().min(0),
});
//# sourceMappingURL=buyer-caregiver-profile.schema.js.map